module.exports = __webpack_public_path__ + "static/media/App.818ce76d.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 1015
// module chunks = 1